module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("For my son, Gavin—a map.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Yeah, it’s "), _c('i', [_vm._v("really")]), _vm._v(" this good.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("It’s even better than I could explain.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Enjoy the New, and enjoy Him!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I’m proud of you, boy.")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 1",
      "src": "images/01.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7eade28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006dedication.vue
// module id = 69
// module chunks = 0